import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sortAdminConversationForm } from '@entities/AdminConversationCategory/api/handlers/sortAdminConversationForm';

export function useSortAdminConversationFormQuery() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: sortAdminConversationForm,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
